import { defineMessages } from 'react-intl';

type MessageKeys = 'expand' | 'collapse';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		expand: {
			id: 'ai-mate.chat-history.message-research.research-expandable.expand',
			defaultMessage: 'Expand',
			description:
				'Button label or action text displayed on a button or clickable element in a research expandable section within the AI conversation interface that expands to show more details about the research process or results. Shown as clickable text on an expand/collapse control. When clicked, it expands the section to reveal its full content. The purpose is to allow users to view additional research details when it has been collapsed to save screen space.',
		},
		collapse: {
			id: 'ai-mate.chat-history.message-research.research-expandable.collapse',
			defaultMessage: 'Collapse',
			description:
				'Button label or action text displayed on a button or clickable element in an expanded research section within the AI conversation interface that collapses to hide research details. Shown as clickable text on an expand/collapse control. When clicked, it collapses the section to hide its content and show only a summary. The purpose is to allow users to minimize research sections to save screen space and reduce visual clutter.',
		},
	});

export default message;
